import { buildWeatherForecastDaySearch } from '../day/dayQuery';

export const WEATHER_FORECAST_BASE_URL = '/maps/weather';

export const WEATHER_FORECAST_LOCATION_SEARCH_PREFIX = `${WEATHER_FORECAST_BASE_URL}/location/search`;

export const getWeatherForecastLocationSearchPath = (
  latitude: number | string,
  longitude: number | string,
  weatherType?: 'general' | 'swell',
  selectedDate?: string,
  defaultDate?: string,
) => {
  const base = `${WEATHER_FORECAST_LOCATION_SEARCH_PREFIX}/${latitude}/${longitude}`;
  const path = weatherType ? `${base}/${weatherType}` : base;
  return `${path}${buildWeatherForecastDaySearch(selectedDate, defaultDate)}`;
};

export const getWeatherForecastHomePath = (
  latitude: number | string,
  longitude: number | string,
  selectedDate?: string,
  defaultDate?: string,
) =>
  `${WEATHER_FORECAST_BASE_URL}/${latitude}/${longitude}${buildWeatherForecastDaySearch(selectedDate, defaultDate)}`;
